import React from 'react';
import styles from '../../styles/components/sections/TrustedBySection.module.css';
import { isSafari } from '../../utils/helpers/utils';
import { useDarkMode } from '../../utils/hooks/useDarkMode';
import { OptimizedImage } from '../common';

/**
 * A reusable component that displays trusted by logos with scrolling animation
 *
 * @param {Object} props
 * @param {Object} props.data - The trusted by data from Strapi
 * @param {String} props.data.title - Section title
 * @param {Array} props.data.trusted_customers - Array of customer logo objects
 */
const TrustedBySection = ({ data }) => {
  const { isDarkMode } = useDarkMode();
  
  if (!data) return null;

  // Filter logos that have valid URLs
  const validLogos = data?.trusted_customers?.filter(item => item?.logo?.url) || [];

  // Duplicate logos for seamless scrolling
  const duplicatedLogos = [...validLogos, ...validLogos,...validLogos, ...validLogos,...validLogos, ...validLogos,...validLogos,...validLogos, ...validLogos];

  return (
    <section className={`py-12 ${isDarkMode ? styles['dark-section'] : ''}`} style={{ background: isDarkMode ? 'var(--bg-primary)' : '#fff' }}>
      <div className="tw-container">
        <div className="row justify-content-center">
          <p className={`text-center ${styles['tb-heading']} ${isDarkMode ? styles['dark-heading'] : ''}`}>{data?.title}</p>
          <div className="row pt-5 justify-content-md-center">
            <div className={styles['scroll-container']}>
              <div className={styles['scroll-content']} >
                {duplicatedLogos.map((item, index) => (
                  <div key={index} className={styles['scroll-item']}>
                    <div className={`${styles['tb-card']} ${isDarkMode ? styles['dark-card'] : ''}`}>
                      <OptimizedImage
                        src={item.logo.url}
                        alt={item.logo.alternativeText || `Trusted partner ${index + 1}`}
                        className={styles['img-settings']}
                        width={84}
                        height={80}
                        style={{ objectFit: 'contain', width: '100%' }}
                        priority={false}
                        loading="lazy"
                        quality={40}
                        sizes="100px"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBySection;
